export enum MediaType {
  TeamsLogo = 'TeamsLogo',
  CompaniesLogo = 'CompaniesLogo',
  LocatePackage = 'LocatePackage',
  DataSourceFile = 'datasourcefile',
  IssueReportCategoryImage = 'IssueReportCategoryImage',
  PointCloud = 'PointCloud'
}
